import { RemoteApprovePurchaseRequest } from "../../../../data/usecases";
import { ApprovePurchaseRequest } from "../../../../domain/usecases";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteApprovePurchaseRequest = (): ApprovePurchaseRequest =>
  new RemoteApprovePurchaseRequest(
    makeApiUrl("/purchases/approve-purchase-request"),
    makeAxiosHttpClient()
  );
